import React, {Component} from 'react';
import {message, PageHeader, Descriptions, Collapse, Form, Tag, Typography,Progress} from 'antd'
import {fetchPost} from "../static/util/fetch";
import { StarOutlined } from '@ant-design/icons'
const { Panel } = Collapse;
const { Paragraph } = Typography;
class CompanyPaceMain extends Component {
    registerCertificatePapersStatus;
    technicalFieldDescriptionStatus;
    researchAuditReportStatus;
    productAuditReportStatus;
    financialAuditReportStatus;
    intermediaryProofStatus;
    taxFormStatus;
    patentTransferSummaryStatus;
    itemConditionStatus;
    overallConditionStatus;
    buildProjectResolutionStatus;
    buildProjectSummaryStatus;
    staffSituationStatus;
    staffRosterStatus;
    staffStructureStatus;
    staffSecurityStatus;
    highTechSpecificStatus;
    ipnonReuseStatus;
    ipsummaryTableStatus;
    ipgeneralSituationStatus;
    ipfunctionStatus;
    openInnovationStatus;
    organizationItemStatus;
    organizationOverAllStatus;
    performanceReviewStatus;
    rdauxiliaryAccountStatus;
    rdcenterStatus;
    rdcenterFoundStatus;
    incentiveStatus;
    rdequipmentStatus;
    rdinvestManageStatus;
    rdprojectManageStatus;
    reserveFundStatus;
    talentAcquisitionStatus;
    techPersonRefreshStatus;
    techPersonTrainStatus;
    rdequipmentPhotoStatus;
    rdexpenseStatus;
    schoolProtocolStatus;
    honorQualificationStatus;
    constructor(props) {
        super(props);
        this.state = {
            companyName:this.props.companyName,
            companyId:this.props.companyId,
            company:[],
            current:0,
            RegisterCertificatePapersStatus: false,
            TechnicalFieldDescriptionStatus:false,
            IPNonReuseStatus:false,
            IPSummaryTableStatus:false,
            IPGeneralSituationStatus:false,
            IPFunctionStatus:false,
            IPUploadSupportPapersStatus:false,
            ResearchAuditReportStatus:false,
            ProductAuditReportStatus:false,
            FinancialAuditReportStatus:false,
            TaxFormStatus:false,
            IntermediaryProofStatus:false,
            PatentTransferSummaryStatus:false,
            PatentTransferSummaryQingdaoStatus:false,
            OverallConditionStatus:false,
            ItemConditionStatus:false,
            BuildProjectSummaryStatus:false,
            BuildProjectResolutionStatus:false,
            ProjectReportStatus:false,
            ReceivingReportStatus:false,
            StaffSituationStatus:false,
            StaffRosterStatus:false,
            StaffStructureStatus:false,
            StaffSecurityStatus:false,
            HighTechSpecificStatus:false,
            OpenInnovationStatus:false,
            OrganizationItemStatus:false,
            OrganizationOverAllStatus:false,
            PatentTransferManageStatus:false,
            PerformanceReviewStatus:false,
            RDAuxiliaryAccountStatus:false,
            RDCenterStatus:false,
            RDCenterFoundStatus:false,
            RDEquipmentStatus:false,
            RDInvestManageStatus:false,
            RDProjectManageStatus:false,
            ReserveFundStatus:false,
            TalentAcquisitionStatus:false,
            TechPersonRefreshStatus:false,
            TechPersonTrainStatus:false,
            RDEquipmentPhotoStatus:false,
            RDExpenseStatus:false,
            SchoolProtocolStatus:false,
            HonorQualificationStatus:false,
            percent1:0,
            percent2:0,
            percent3:0,
            percent4:0,
            percent5:0,
            percent6:0,
            percent7:0,
            percent8:0,
            percent9:0,
            systemName:'',
        }
    }
    componentDidMount() {
        fetchPost(global.constants.getSysConfig,{})
            .then(
                res=>{
                    if(res.code === 200){
                        this.setState(()=>({
                            systemName:res.data.systemName,
                            systemColor:res.data.systemColor
                        }))
                        if(res.data.systemColor === 1){
                            require([`../style.css`], function(list){});
                        }
                        if(res.data.systemColor === 2){
                            require([`../styleOrange.css`], function(list){});
                        }
                        if(res.data.systemColor === 3){
                            require([`../styleGray.css`], function(list){});
                        }
                    }
                }
            )
        fetchPost(global.constants.getCompany,{id:this.state.companyId})
            .then(
                res=>{
                    if(res.code === 200){
                        this.setState(()=>({
                            company:res.data
                        }))
                    }else{
                        message.info(res.msg).then();
                    }
                }
            )
        fetchPost(global.constants.checkProcess, {id:this.state.companyId})
            .then(
                res=> {
                    if (res.code === 200) {
                        this.setState(() => ({
                            RegisterCertificatePapersStatus: res.data.registerCertificatePapersStatus,
                            TechnicalFieldDescriptionStatus:res.data.technicalFieldDescriptionStatus,
                            ResearchAuditReportStatus:res.data.researchAuditReportStatus,
                            ProductAuditReportStatus:res.data.productAuditReportStatus,
                            FinancialAuditReportStatus:res.data.financialAuditReportStatus,
                            TaxFormStatus:res.data.taxFormStatus,
                            IntermediaryProofStatus:res.data.intermediaryProofStatus,
                            PatentTransferSummaryStatus:res.data.patentTransferSummaryStatus,
                            OverallConditionStatus:res.data.overallConditionStatus,
                            ItemConditionStatus:res.data.itemConditionStatus,
                            BuildProjectSummaryStatus:res.data.buildProjectSummaryStatus,
                            BuildProjectResolutionStatus:res.data.buildProjectResolutionStatus,
                            StaffSituationStatus:res.data.staffSituationStatus,
                            StaffRosterStatus:res.data.staffRosterStatus,
                            StaffStructureStatus:res.data.staffStructureStatus,
                            StaffSecurityStatus:res.data.staffSecurityStatus,
                            HighTechSpecificStatus:res.data.highTechSpecificStatus,
                            IPNonReuseStatus:res.data.ipnonReuseStatus,
                            IPSummaryTableStatus:res.data.ipsummaryTableStatus,
                            IPGeneralSituationStatus:res.data.ipgeneralSituationStatus,
                            IPFunctionStatus:res.data.ipfunctionStatus,
                            OpenInnovationStatus:res.data.openInnovationStatus,
                            OrganizationItemStatus:res.data.organizationItemStatus,
                            OrganizationOverAllStatus:res.data.organizationOverAllStatus,
                            PatentTransferManageStatus:res.data.incentiveStatus,
                            PerformanceReviewStatus:res.data.performanceReviewStatus,
                            RDAuxiliaryAccountStatus:res.data.rdauxiliaryAccountStatus,
                            RDCenterStatus:res.data.rdcenterStatus,
                            RDCenterFoundStatus:res.data.rdcenterFoundStatus,
                            RDEquipmentStatus:res.data.rdequipmentStatus,
                            RDInvestManageStatus:res.data.rdinvestManageStatus,
                            RDProjectManageStatus:res.data.rdprojectManageStatus,
                            ReserveFundStatus:res.data.reserveFundStatus,
                            TalentAcquisitionStatus:res.data.talentAcquisitionStatus,
                            TechPersonRefreshStatus:res.data.techPersonRefreshStatus,
                            TechPersonTrainStatus:res.data.techPersonTrainStatus,
                            RDEquipmentPhotoStatus:res.data.rdequipmentPhotoStatus,
                            RDExpenseStatus:res.data.rdexpenseStatus,
                            SchoolProtocolStatus:res.data.schoolProtocolStatus,
                            HonorQualificationStatus:res.data.honorQualificationStatus,
                        }))
                        if (this.state.company.area === '江苏') {
                            if (this.state.RegisterCertificatePapersStatus === true) {
                                this.setState(() => ({percent1: this.state.percent1 + 1}))
                            }
                            if (this.state.IPNonReuseStatus === true) {
                                this.setState(() => ({percent2: this.state.percent2 + 1}))
                            }
                            if (this.state.IPSummaryTableStatus === true) {
                                this.setState(() => ({percent2: this.state.percent2 + 1}))
                            }
                            if (this.state.ResearchAuditReportStatus === true) {
                                this.setState(() => ({percent3: this.state.percent3 + 1}))
                            }
                            if (this.state.ProductAuditReportStatus === true) {
                                this.setState(() => ({percent3: this.state.percent3 + 1}))
                            }
                            if (this.state.FinancialAuditReportStatus === true) {
                                this.setState(() => ({percent3: this.state.percent3 + 1}))
                            }
                            if (this.state.TaxFormStatus === true) {
                                this.setState(() => ({percent3: this.state.percent3 + 1}))
                            }
                            if (this.state.IntermediaryProofStatus === true) {
                                this.setState(() => ({percent3: this.state.percent3 + 1}))
                            }
                            if (this.state.PatentTransferSummaryStatus === true) {
                                this.setState(() => ({percent4: this.state.percent4 + 1}))
                            }
                            if (this.state.OverallConditionStatus === true) {
                                this.setState(() => ({percent4: this.state.percent4 + 1}))
                            }
                            if (this.state.ItemConditionStatus === true) {
                                this.setState(() => ({percent4: this.state.percent4 + 1}))
                            }
                            if (this.state.BuildProjectSummaryStatus === true) {
                                this.setState(() => ({percent5: this.state.percent5 + 1}))
                            }
                            if (this.state.BuildProjectResolutionStatus === true) {
                                this.setState(() => ({
                                    percent5: this.state.percent5 + 1
                                }))
                            }
                            if (this.state.StaffSituationStatus === true) {
                                this.setState(() => ({
                                    percent6: this.state.percent6 + 1
                                }))
                            }
                            if (this.state.StaffStructureStatus === true) {
                                this.setState(() => ({
                                    percent6: this.state.percent6 + 1
                                }))
                            }
                            if (this.state.StaffRosterStatus === true) {
                                this.setState(() => ({
                                    percent6: this.state.percent6 + 1
                                }))
                            }
                            if (this.state.StaffSecurityStatus === true) {
                                this.setState(() => ({
                                    percent6: this.state.percent6 + 1
                                }))
                            }
                            if (this.state.HighTechSpecificStatus === true) {
                                this.setState(() => ({
                                    percent7: this.state.percent7 + 1
                                }))
                            }
                            if (this.state.OpenInnovationStatus === true) {
                                this.setState(() => ({
                                    percent8: this.state.percent8 + 1
                                }))
                            }
                            if (this.state.OrganizationItemStatus === true) {
                                this.setState(() => ({
                                    percent8: this.state.percent8 + 1
                                }))
                            }
                            if (this.state.OrganizationOverAllStatus === true) {
                                this.setState(() => ({
                                    percent8: this.state.percent8 + 1
                                }))
                            }
                            if (this.state.PatentTransferManageStatus === true) {
                                this.setState(() => ({
                                    percent8: this.state.percent8 + 1
                                }))
                            }
                            if (this.state.PerformanceReviewStatus === true) {
                                this.setState(() => ({
                                    percent8: this.state.percent8 + 1
                                }))
                            }
                            if (this.state.RDAuxiliaryAccountStatus === true) {
                                this.setState(() => ({
                                    percent8: this.state.percent8 + 1
                                }))
                            }
                            if (this.state.RDCenterFoundStatus === true) {
                                this.setState(() => ({
                                    percent8: this.state.percent8 + 1
                                }))
                            }
                            if (this.state.RDCenterStatus === true) {
                                this.setState(() => ({
                                    percent8: this.state.percent8 + 1
                                }))
                            }
                            if (this.state.RDEquipmentStatus === true) {
                                this.setState(() => ({
                                    percent8: this.state.percent8 + 1
                                }))
                            }
                            if (this.state.RDEquipmentPhotoStatus === true) {
                                this.setState(() => ({
                                    percent8: this.state.percent8 + 1
                                }))
                            }
                            if (this.state.RDExpenseStatus === true) {
                                this.setState(() => ({
                                    percent8: this.state.percent8 + 1
                                }))
                            }
                            if (this.state.RDInvestManageStatus === true) {
                                this.setState(() => ({
                                    percent8: this.state.percent8 + 1
                                }))
                            }
                            if (this.state.RDProjectManageStatus === true) {
                                this.setState(() => ({
                                    percent8: this.state.percent8 + 1
                                }))
                            }
                            if (this.state.ReserveFundStatus === true) {
                                this.setState(() => ({
                                    percent8: this.state.percent8 + 1
                                }))
                            }
                            // if (this.state.SchoolProtocolStatus === true) {
                            //     this.setState(() => ({
                            //         percent8: this.state.percent8 + 1
                            //     }))
                            // }//产学研不计入
                            if (this.state.TalentAcquisitionStatus === true) {
                                this.setState(() => ({
                                    percent8: this.state.percent8 + 1
                                }))
                            }
                            if (this.state.TechPersonRefreshStatus === true) {
                                this.setState(() => ({
                                    percent8: this.state.percent8 + 1
                                }))
                            }
                            if (this.state.TechPersonTrainStatus === true) {
                                this.setState(() => ({
                                    percent8: this.state.percent8 + 1
                                }))
                            }
                            if (this.state.HonorQualificationStatus === true) {
                                this.setState(() => ({
                                    percent9: this.state.percent9 + 1
                                }))
                            }
                            //模块计数
                            if (this.state.RegisterCertificatePapersStatus === true) {
                                this.setState(() => ({
                                    current: this.state.current + 1
                                }))
                            }
                            if (this.state.IPNonReuseStatus === true && this.state.IPSummaryTableStatus === true) {
                                this.setState(() => ({
                                    current: this.state.current + 1
                                }))
                            }
                            if(this.state.PatentTransferSummaryStatus === true &&
                                this.state.OverallConditionStatus === true &&
                                this.state.ItemConditionStatus === true
                            ){
                                this.setState(() => ({
                                    current: this.state.current + 1
                                }))
                            }
                            if(this.state.ResearchAuditReportStatus === true &&
                                this.state.FinancialAuditReportStatus === true &&
                                this.state.ProductAuditReportStatus === true &&
                                this.state.TaxFormStatus === true &&
                                this.state.IntermediaryProofStatus === true
                            ){
                                this.setState(() => ({
                                    current: this.state.current + 1
                                }))

                            }
                            if(this.state.BuildProjectSummaryStatus === true &&
                                this.state.BuildProjectResolutionStatus === true
                            ){
                                this.setState(() => ({
                                    current: this.state.current + 1
                                }))

                            }
                            if(this.state.StaffSituationStatus === true){
                                this.setState(() => ({
                                    current: this.state.current + 1
                                }))

                            }
                            if(this.state.HighTechSpecificStatus === true){
                                this.setState(() => ({
                                    current: this.state.current + 1
                                }))

                            }
                            if(this.state.OpenInnovationStatus === true &&
                                this.state.OrganizationItemStatus === true &&
                                this.state.OrganizationOverAllStatus === true &&
                                this.state.PatentTransferManageStatus === true &&
                                this.state.PerformanceReviewStatus === true &&
                                this.state.RDAuxiliaryAccountStatus === true &&
                                this.state.RDCenterFoundStatus === true &&
                                this.state.RDCenterStatus === true &&
                                this.state.RDEquipmentStatus === true &&
                                this.state.RDEquipmentPhotoStatus === true &&
                                this.state.RDExpenseStatus === true &&
                                this.state.RDInvestManageStatus === true &&
                                this.state.RDProjectManageStatus === true &&
                                this.state.ReserveFundStatus === true &&
                               // this.state.SchoolProtocolStatus === true &&
                                this.state.TalentAcquisitionStatus === true &&
                                this.state.TechPersonRefreshStatus === true &&
                                this.state.TechPersonTrainStatus === true
                            ){
                                this.setState(() => ({
                                    current: this.state.current + 1
                                }))
                            }
                            // if(this.state.HonorQualificationStatus === true) {
                            //     this.setState(() => ({
                            //         current: this.state.current + 1
                            //     }))
                            // }
                        }
                        if (this.state.company.area === '青岛') {
                            if (this.state.RegisterCertificatePapersStatus === true){
                                this.setState(() => ({
                                    percent1: this.state.percent1 + 1
                                }))
                            }
                            if (this.state.TechnicalFieldDescriptionStatus === true){
                                this.setState(() => ({
                                    percent1: this.state.percent1 + 1
                                }))
                            }
                            if (this.state.IPNonReuseStatus === true){
                                this.setState(() => ({
                                    percent2: this.state.percent2 + 1
                                }))
                            }
                            if(this.state.IPSummaryTableStatus === true){
                                this.setState(() => ({
                                    percent2: this.state.percent2 + 1
                                }))
                            }
                            if(this.state.IPFunctionStatus === true){
                                this.setState(() => ({
                                    percent2: this.state.percent2 + 1
                                }))
                            }
                            if(this.state.IPGeneralSituationStatus === true){
                                this.setState(() => ({
                                    percent2: this.state.percent2 + 1
                                }))
                            }
                            if(this.state.ResearchAuditReportStatus === true){
                                this.setState(() => ({
                                    percent3: this.state.percent3 + 1
                                }))
                            }
                            if (this.state.ProductAuditReportStatus === true) {
                                this.setState(() => ({percent3: this.state.percent3 + 1}))
                            }
                            if(this.state.FinancialAuditReportStatus === true){
                                this.setState(() => ({
                                    percent3: this.state.percent3 + 1
                                }))
                            }
                            if(this.state.TaxFormStatus === true){
                                this.setState(() => ({
                                    percent3: this.state.percent3 + 1
                                }))
                            }
                            if(this.state.IntermediaryProofStatus === true) {
                                this.setState(() => ({
                                    percent3: this.state.percent3 + 1
                                }))
                            }
                            if(this.state.PatentTransferSummaryStatus === true
                            ){
                                this.setState(() => ({
                                    percent4: this.state.percent4 + 1
                                }))
                            }
                            if(this.state.OverallConditionStatus === true){
                                this.setState(() => ({
                                    percent4: this.state.percent4 + 1
                                }))
                            }
                            if(this.state.ItemConditionStatus === true){
                                this.setState(() => ({
                                    percent4: this.state.percent4 + 1
                                }))
                            }
                            if(this.state.BuildProjectSummaryStatus === true){
                                this.setState(() => ({
                                    percent5: this.state.percent5 + 1
                                }))
                            }
                            if(this.state.BuildProjectResolutionStatus === true){
                                this.setState(() => ({
                                    percent5: this.state.percent5 + 1
                                }))
                            }
                            if(this.state.StaffStructureStatus === true){
                                this.setState(() => ({
                                    percent6: this.state.percent6 + 1
                                }))
                            }
                            if(this.state.StaffRosterStatus === true){
                                this.setState(() => ({
                                    percent6: this.state.percent6 + 1
                                }))
                            }
                            if(this.state.StaffSecurityStatus === true){
                                this.setState(() => ({
                                    percent6: this.state.percent6 + 1
                                }))
                            }
                            if(this.state.OpenInnovationStatus === true) {
                                this.setState(() => ({
                                    percent8: this.state.percent8 + 1
                                }))
                            }
                            if(this.state.OrganizationItemStatus === true) {
                                this.setState(() => ({
                                    percent8: this.state.percent8 + 1
                                }))
                            }
                            if(this.state.OrganizationOverAllStatus === true) {
                                this.setState(() => ({
                                    percent8: this.state.percent8 + 1
                                }))
                            }
                            if(this.state.PatentTransferManageStatus === true) {
                                this.setState(() => ({
                                    percent8: this.state.percent8 + 1
                                }))
                            }
                            if(this.state.PerformanceReviewStatus === true) {
                                this.setState(() => ({
                                    percent8: this.state.percent8 + 1
                                }))
                            }
                            if(this.state.RDAuxiliaryAccountStatus === true) {
                                this.setState(() => ({
                                    percent8: this.state.percent8 + 1
                                }))
                            }
                            if(this.state.RDCenterFoundStatus === true){
                                this.setState(() => ({
                                    percent8: this.state.percent8 + 1
                                }))
                            }
                            if(this.state.RDCenterStatus === true){
                                this.setState(() => ({
                                    percent8: this.state.percent8 + 1
                                }))
                            }
                            if(this.state.RDEquipmentStatus === true){
                                this.setState(() => ({
                                    percent8: this.state.percent8 + 1
                                }))
                            }
                            if(this.state.RDEquipmentPhotoStatus === true){
                                this.setState(() => ({
                                    percent8: this.state.percent8 + 1
                                }))
                            }
                            if(this.state.RDExpenseStatus === true){
                                this.setState(() => ({
                                    percent8: this.state.percent8 + 1
                                }))
                            }
                            if(this.state.RDInvestManageStatus === true){
                                this.setState(() => ({
                                    percent8: this.state.percent8 + 1
                                }))
                            }
                            if(this.state.RDProjectManageStatus === true){
                                this.setState(() => ({
                                    percent8: this.state.percent8 + 1
                                }))
                            }
                            if(this.state.ReserveFundStatus === true){
                                this.setState(() => ({
                                    percent8: this.state.percent8 + 1
                                }))
                            }
                            // if(this.state.SchoolProtocolStatus === true){
                            //     this.setState(() => ({
                            //         percent8: this.state.percent8 + 1
                            //     }))
                            // }
                            if(this.state.TalentAcquisitionStatus === true){
                                this.setState(() => ({
                                    percent8: this.state.percent8 + 1
                                }))
                            }
                            if(this.state.TechPersonRefreshStatus === true){
                                this.setState(() => ({
                                    percent8: this.state.percent8 + 1
                                }))
                            }
                            if(this.state.TechPersonTrainStatus === true){
                                this.setState(() => ({
                                    percent8: this.state.percent8 + 1
                                }))
                            }
                            if(this.state.HonorQualificationStatus === true) {
                                this.setState(() => ({
                                    percent9: this.state.percent9 + 1
                                }))
                            }
                            //模块计数
                            if (this.state.RegisterCertificatePapersStatus === true &&
                            this.state.TechnicalFieldDescriptionStatus === true) {
                                this.setState(() => ({
                                    current: this.state.current + 1
                                }))
                            }
                            if (this.state.IPNonReuseStatus === true && this.state.IPSummaryTableStatus === true
                            && this.state.IPGeneralSituationStatus === true && this.state.IPFunctionStatus === true) {
                                this.setState(() => ({
                                    current: this.state.current + 1
                                }))
                            }
                            if(this.state.PatentTransferSummaryStatus === true &&
                                this.state.OverallConditionStatus === true &&
                                this.state.ItemConditionStatus === true
                            ){
                                this.setState(() => ({
                                    current: this.state.current + 1
                                }))
                            }
                            if(this.state.ResearchAuditReportStatus === true &&
                                this.state.FinancialAuditReportStatus === true &&
                                this.state.ProductAuditReportStatus === true &&
                                this.state.TaxFormStatus === true &&
                                this.state.IntermediaryProofStatus === true
                            ){
                                this.setState(() => ({
                                    current: this.state.current + 1
                                }))
                            }
                            if(this.state.BuildProjectSummaryStatus === true &&
                            this.state.BuildProjectResolutionStatus === true){
                                this.setState(() => ({
                                    current: this.state.current + 1
                                }))
                            }
                            if(
                                this.state.StaffStructureStatus === true &&
                                this.state.StaffRosterStatus === true &&
                                this.state.StaffSecurityStatus === true
                            ){
                                this.setState(() => ({
                                    current: this.state.current + 1
                                }))
                            }
                            if(this.state.OpenInnovationStatus === true &&
                                this.state.OrganizationItemStatus === true &&
                                this.state.OrganizationOverAllStatus === true &&
                                this.state.PatentTransferManageStatus === true &&
                                this.state.PerformanceReviewStatus === true &&
                                this.state.RDAuxiliaryAccountStatus === true &&
                                this.state.RDCenterFoundStatus === true &&
                                this.state.RDCenterStatus === true &&
                                this.state.RDEquipmentStatus === true &&
                                this.state.RDEquipmentPhotoStatus === true &&
                                this.state.RDExpenseStatus === true &&
                                this.state.RDInvestManageStatus === true &&
                                this.state.RDProjectManageStatus === true &&
                                this.state.ReserveFundStatus === true &&
                                //this.state.SchoolProtocolStatus === true &&
                                this.state.TalentAcquisitionStatus === true &&
                                this.state.TechPersonRefreshStatus === true &&
                                this.state.TechPersonTrainStatus === true
                            ){
                                this.setState(() => ({
                                    current: this.state.current + 1
                                }))
                            }
                            // if(this.state.HonorQualificationStatus === true) {
                            //     this.setState(() => ({
                            //         current: this.state.current + 1
                            //     }))
                            // }
                        }
                        if (this.state.company.area === '山东其他地区') {
                            if (this.state.RegisterCertificatePapersStatus === true){
                                this.setState(() => ({
                                    percent1: this.state.percent1 + 1
                                }))
                            }
                            if (this.state.TechnicalFieldDescriptionStatus === true){
                                this.setState(() => ({
                                    percent1: this.state.percent1 + 1
                                }))
                            }
                            if (this.state.IPNonReuseStatus === true){
                                this.setState(() => ({
                                    percent2: this.state.percent2 + 1
                                }))
                            }
                            if(this.state.IPSummaryTableStatus === true){
                                this.setState(() => ({
                                    percent2: this.state.percent2 + 1
                                }))
                            }
                            if(this.state.ResearchAuditReportStatus === true){
                                this.setState(() => ({
                                    percent3: this.state.percent3 + 1
                                }))
                            }
                            if (this.state.ProductAuditReportStatus === true) {
                                this.setState(() => ({percent3: this.state.percent3 + 1}))
                            }
                            if(this.state.FinancialAuditReportStatus === true){
                                this.setState(() => ({
                                    percent3: this.state.percent3 + 1
                                }))
                            }
                            if(this.state.TaxFormStatus === true){
                                this.setState(() => ({
                                    percent3: this.state.percent3 + 1
                                }))
                            }
                            if(this.state.IntermediaryProofStatus === true) {
                                this.setState(() => ({
                                    percent3: this.state.percent3 + 1
                                }))
                            }
                            if(this.state.PatentTransferSummaryStatus === true
                            ){
                                this.setState(() => ({
                                    percent4: this.state.percent4 + 1
                                }))
                            }
                            if(this.state.OverallConditionStatus === true){
                                this.setState(() => ({
                                    percent4: this.state.percent4 + 1
                                }))
                            }
                            if(this.state.ItemConditionStatus === true){
                                this.setState(() => ({
                                    percent4: this.state.percent4 + 1
                                }))
                            }
                            if(this.state.BuildProjectSummaryStatus === true){
                                this.setState(() => ({
                                    percent5: this.state.percent5 + 1
                                }))
                            }
                            if(this.state.BuildProjectResolutionStatus === true){
                                this.setState(() => ({
                                    percent5: this.state.percent5 + 1
                                }))
                            }
                            if(this.state.StaffRosterStatus === true){
                                this.setState(() => ({
                                    percent6: this.state.percent6 + 1
                                }))
                            }
                            if(this.state.StaffSecurityStatus === true){
                                this.setState(() => ({
                                    percent6: this.state.percent6 + 1
                                }))
                            }
                            if(this.state.HighTechSpecificStatus === true) {
                                this.setState(() => ({
                                    percent7: this.state.percent7 + 1
                                }))
                            }
                            if(this.state.OpenInnovationStatus === true) {
                                this.setState(() => ({
                                    percent8: this.state.percent8 + 1
                                }))
                            }
                            if(this.state.OrganizationItemStatus === true) {
                                this.setState(() => ({
                                    percent8: this.state.percent8 + 1
                                }))
                            }
                            if(this.state.OrganizationOverAllStatus === true) {
                                this.setState(() => ({
                                    percent8: this.state.percent8 + 1
                                }))
                            }
                            if(this.state.PatentTransferManageStatus === true) {
                                this.setState(() => ({
                                    percent8: this.state.percent8 + 1
                                }))
                            }
                            if(this.state.PerformanceReviewStatus === true) {
                                this.setState(() => ({
                                    percent8: this.state.percent8 + 1
                                }))
                            }
                            if(this.state.RDAuxiliaryAccountStatus === true) {
                                this.setState(() => ({
                                    percent8: this.state.percent8 + 1
                                }))
                            }
                            if(this.state.RDCenterFoundStatus === true){
                                this.setState(() => ({
                                    percent8: this.state.percent8 + 1
                                }))
                            }
                            if(this.state.RDCenterStatus === true){
                                this.setState(() => ({
                                    percent8: this.state.percent8 + 1
                                }))
                            }
                            if(this.state.RDEquipmentStatus === true){
                                this.setState(() => ({
                                    percent8: this.state.percent8 + 1
                                }))
                            }
                            if(this.state.RDEquipmentPhotoStatus === true){
                                this.setState(() => ({
                                    percent8: this.state.percent8 + 1
                                }))
                            }
                            if(this.state.RDExpenseStatus === true){
                                this.setState(() => ({
                                    percent8: this.state.percent8 + 1
                                }))
                            }
                            if(this.state.RDInvestManageStatus === true){
                                this.setState(() => ({
                                    percent8: this.state.percent8 + 1
                                }))
                            }
                            if(this.state.RDProjectManageStatus === true){
                                this.setState(() => ({
                                    percent8: this.state.percent8 + 1
                                }))
                            }
                            if(this.state.ReserveFundStatus === true){
                                this.setState(() => ({
                                    percent8: this.state.percent8 + 1
                                }))
                            }
                            // if(this.state.SchoolProtocolStatus === true){
                            //     this.setState(() => ({
                            //         percent8: this.state.percent8 + 1
                            //     }))
                            // }//产学研选填不计入
                            if(this.state.TalentAcquisitionStatus === true){
                                this.setState(() => ({
                                    percent8: this.state.percent8 + 1
                                }))
                            }
                            if(this.state.TechPersonRefreshStatus === true){
                                this.setState(() => ({
                                    percent8: this.state.percent8 + 1
                                }))
                            }
                            if(this.state.TechPersonTrainStatus === true){
                                this.setState(() => ({
                                    percent8: this.state.percent8 + 1
                                }))
                            }
                            if(this.state.HonorQualificationStatus === true) {
                                this.setState(() => ({
                                    percent9: this.state.percent9 + 1
                                }))
                            }

                            //模块计数
                            if (this.state.RegisterCertificatePapersStatus === true &&
                                this.state.TechnicalFieldDescriptionStatus === true) {
                                this.setState(() => ({
                                    current: this.state.current + 1
                                }))
                            }
                            if (this.state.IPNonReuseStatus === true && this.state.IPSummaryTableStatus === true) {
                                this.setState(() => ({
                                    current: this.state.current + 1
                                }))
                            }
                            if(this.state.PatentTransferSummaryStatus === true &&
                                this.state.OverallConditionStatus === true &&
                                this.state.ItemConditionStatus === true
                            ){
                                this.setState(() => ({
                                    current: this.state.current + 1
                                }))
                            }
                            if(this.state.ResearchAuditReportStatus === true &&
                                this.state.FinancialAuditReportStatus === true &&
                                this.state.ProductAuditReportStatus === true &&
                                this.state.TaxFormStatus === true &&
                                this.state.IntermediaryProofStatus === true
                            ){
                                this.setState(() => ({
                                    current: this.state.current + 1
                                }))

                            }
                            if(this.state.BuildProjectSummaryStatus === true &&
                                this.state.BuildProjectResolutionStatus === true
                            ){
                                this.setState(() => ({
                                    current: this.state.current + 1
                                }))

                            }
                            if(
                                this.state.StaffRosterStatus === true &&
                                this.state.StaffSecurityStatus === true
                            ){
                                this.setState(() => ({
                                    current: this.state.current + 1
                                }))
                            }
                            if(this.state.OpenInnovationStatus === true &&
                                this.state.OrganizationItemStatus === true &&
                                this.state.OrganizationOverAllStatus === true &&
                                this.state.PatentTransferManageStatus === true &&
                                this.state.PerformanceReviewStatus === true &&
                                this.state.RDAuxiliaryAccountStatus === true &&
                                this.state.RDCenterFoundStatus === true &&
                                this.state.RDCenterStatus === true &&
                                this.state.RDEquipmentStatus === true &&
                                this.state.RDEquipmentPhotoStatus === true &&
                                this.state.RDExpenseStatus === true &&
                                this.state.RDInvestManageStatus === true &&
                                this.state.RDProjectManageStatus === true &&
                                this.state.ReserveFundStatus === true &&
                                //this.state.SchoolProtocolStatus === true &&
                                this.state.TalentAcquisitionStatus === true &&
                                this.state.TechPersonRefreshStatus === true &&
                                this.state.TechPersonTrainStatus === true
                            ){
                                this.setState(() => ({
                                    current: this.state.current + 1
                                }))
                            }
                            // if(this.state.HonorQualificationStatus === true) {
                            //     this.setState(() => ({
                            //         current: this.state.current + 1
                            //     }))
                            // }
                        }
                    }
                })
    }
    render() {
        const Content1 = (
            <div>
                <StarOutlined style={{marginRight:'5px'}}/>建立公司、高新产品、项目与知识产权之间的关系
            </div>
        )
        const Content2 = (
            <Collapse bordered={false}>
                <Panel header="展开全部" key="1">
                    <Form>
                        <Form.Item label="营业执照" name="RegisterCertificatePapersStatus">
                            {this.state.RegisterCertificatePapersStatus === true?
                                <Tag color="green" className="Tag_style" >已上传</Tag>:
                                <Tag color="red" className="Tag_style">未上传</Tag>}
                        </Form.Item>
                        <Form.Item label="技术领域说明" name="TechnicalFieldDescriptionStatus">
                            {
                                this.state.company.area === '江苏'&&
                                <Tag color="gray" className="Tag_style" >江苏无此文件</Tag>
                            }
                            {this.state.TechnicalFieldDescriptionStatus === true&&
                            this.state.company.area !== '江苏'&&
                            <Tag color="green" className="Tag_style" >已生成</Tag>}
                            {this.state.TechnicalFieldDescriptionStatus === false&&
                            this.state.company.area !== '江苏'&&
                            <Tag color="red" className="Tag_style">未生成</Tag>}
                        </Form.Item>
                    </Form>
                </Panel>
            </Collapse>
        )
        const Content3 = (
            <Collapse bordered={false}>
                <Panel header="展开全部" key="2">
                    <Paragraph>
                        <pre>Tips：此项不包括知识产权证明材料的上传。</pre>
                    </Paragraph>
                    <Form>
                        <Form.Item label="知识产权未重复使用说明" name="IPNonReuseStatus">
                            {this.state.IPNonReuseStatus === true?
                                <Tag color="green" className="Tag_style" >已生成</Tag>:
                                <Tag color="red" className="Tag_style">未生成</Tag>}
                        </Form.Item>
                        <Form.Item label="知识产权情况汇总表" name="IPSummaryTableStatus">
                            {this.state.IPSummaryTableStatus === true?
                                <Tag color="green" className="Tag_style" >已生成</Tag>:
                                <Tag color="red" className="Tag_style">未生成</Tag>}
                        </Form.Item>
                        <Form.Item label="知识产权概况" name="IPGeneralSituationStatus">
                            {
                                this.state.company.area === '江苏'&&
                                <Tag color="gray" className="Tag_style" >江苏无此文件</Tag>
                            }
                            {
                                this.state.company.area === '山东其他地区'&&
                                <Tag color="gray" className="Tag_style" >山东其他地区无此文件</Tag>
                            }
                            {this.state.IPGeneralSituationStatus === true&&
                            this.state.company.area !== '江苏'&&
                            this.state.company.area !== '山东其他地区'&&
                            <Tag color="green" className="Tag_style" >已生成</Tag>}
                            {this.state.IPGeneralSituationStatus === false&&
                            this.state.company.area !== '江苏'&&
                            this.state.company.area !== '山东其他地区'&&
                            <Tag color="red" className="Tag_style">未生成</Tag>}
                        </Form.Item>
                        <Form.Item
                            label="知识产权对主要产品（服务）在技术上发挥和信心作用介绍"
                            name="IPFunctionStatus">
                            {
                                this.state.company.area === '江苏'&&
                                <Tag color="gray" className="Tag_style" >江苏无此文件</Tag>
                            }
                            {
                                this.state.company.area === '山东其他地区'&&
                                <Tag color="gray" className="Tag_style" >山东其他地区无此文件</Tag>
                            }
                            {this.state.IPFunctionStatus === true&&
                            this.state.company.area !== '江苏'&&
                            this.state.company.area !== '山东其他地区'&&
                            <Tag color="green" className="Tag_style" >已生成</Tag>}
                            {this.state.IPFunctionStatus === false&&
                            this.state.company.area !== '江苏'&&
                            this.state.company.area !== '山东其他地区'&&
                            <Tag color="red" className="Tag_style">未生成</Tag>}
                        </Form.Item>
                    </Form>
                </Panel>
            </Collapse>
        )
        const Content4 = (
            <Collapse bordered={false}>
                <Panel header="展开全部" key="3">
                    <Paragraph>
                        <pre>Tips：高品专项审计报告属于选填项，若其未上传而其他项已上传,此步骤视为完成。</pre>
                    </Paragraph>
                    <Form>
                        <Form.Item label="研发费用专项审计报告" name="ResearchAuditReportStatus">
                            {this.state.ResearchAuditReportStatus === true?
                                <Tag color="green" className="Tag_style" >已上传</Tag>:
                                <Tag color="red" className="Tag_style">未上传</Tag>}
                        </Form.Item>
                        <Form.Item label="高品专项审计报告" name="ProductAuditReportStatus">
                            {this.state.ProductAuditReportStatus === true?
                                <Tag color="green" className="Tag_style" >已上传</Tag>:
                                <Tag color="red" className="Tag_style">未上传</Tag>}
                        </Form.Item>
                        <Form.Item label="财务审计报告" name="FinancialAuditReportStatus">
                            {this.state.FinancialAuditReportStatus === true?
                                <Tag color="green" className="Tag_style" >已上传</Tag>:
                                <Tag color="red" className="Tag_style">未上传</Tag>}
                        </Form.Item>
                        <Form.Item label="纳税申报表" name="TaxFormStatus">
                            {this.state.TaxFormStatus === true?
                                <Tag color="green" className="Tag_style" >已上传</Tag>:
                                <Tag color="red" className="Tag_style">未上传</Tag>}
                        </Form.Item>
                        <Form.Item label="中介证明" name="IntermediaryProofStatus">
                            {this.state.IntermediaryProofStatus === true?
                                <Tag color="green" className="Tag_style" >已上传</Tag>:
                                <Tag color="red" className="Tag_style">未上传</Tag>}
                        </Form.Item>
                    </Form>
                </Panel>
            </Collapse>
        )
        const Content5 = (
            <Collapse bordered={false}>
                <Panel header="展开全部" key="3">
                    <Paragraph>
                        <pre>Tips：此项不包括成果转化证明材料的上传。</pre>
                    </Paragraph>
                    <Form>
                        <Form.Item label="近三年成果转化汇总表" name="PatentTransferSummaryStatus">
                            {this.state.PatentTransferSummaryStatus === true?
                                <Tag color="green" className="Tag_style" >已生成</Tag>:
                                <Tag color="red" className="Tag_style">未生成</Tag>}
                        </Form.Item>
                        <Form.Item label="科技成果总体情况说明" name="OverallConditionStatus">
                            {this.state.OverallConditionStatus === true?
                                <Tag color="green" className="Tag_style" >已生成</Tag>:
                                <Tag color="red" className="Tag_style">未生成</Tag>}
                        </Form.Item>
                        <Form.Item label="科技成果逐项说明" name="ItemConditionStatus">
                            {this.state.ItemConditionStatus === true?
                                <Tag color="green" className="Tag_style" >已生成</Tag>:
                                <Tag color="red" className="Tag_style">未生成</Tag>}
                        </Form.Item>
                    </Form>
                </Panel>
            </Collapse>
        )
        const Content6 = (
            <Collapse bordered={false}>
                <Panel header="展开全部" key="4">
                    <Paragraph>
                        <pre>Tips：此项不包括立项报告和验收报告。</pre>
                    </Paragraph>
                    <Form>
                        <Form.Item label="项目立项汇总表" name="BuildProjectSummaryStatus">
                            {this.state.BuildProjectSummaryStatus === true?
                                <Tag color="green" className="Tag_style" >已生成</Tag>:
                                <Tag color="red" className="Tag_style">未生成</Tag>}
                        </Form.Item>
                        <Form.Item label="立项材料" name="BuildProjectResolutionStatus">
                            {this.state.BuildProjectResolutionStatus === true?
                                <Tag color="green" className="Tag_style" >已上传并生成</Tag>:
                                <Tag color="red" className="Tag_style">未上传</Tag>}
                        </Form.Item>
                    </Form>
                </Panel>
            </Collapse>
        )
        const Content7 = (
            <Collapse bordered={false}>
                <Panel header="展开全部" key="5">
                    <Form>
                        <Form.Item label="人员情况表" name="StaffSituationStatus">
                            {
                                this.state.company.area === '青岛'&&
                                <Tag color="gray" className="Tag_style" >青岛无此文件</Tag>
                            }
                            {
                                this.state.company.area === '山东其他地区'&&
                                <Tag color="gray" className="Tag_style" >山东其他地区无此文件</Tag>
                            }
                            {this.state.StaffSituationStatus === true&&
                            this.state.company.area === '江苏'&&
                            <Tag color="green" className="Tag_style" >已生成</Tag>}
                            {this.state.StaffSituationStatus === false&&
                            this.state.company.area === '江苏'&&
                            <Tag color="red" className="Tag_style">未生成</Tag>}
                        </Form.Item>
                        <Form.Item label="人员花名册" name="StaffRosterStatus">
                            {this.state.StaffRosterStatus === true?
                                <Tag color="green" className="Tag_style" >已生成</Tag>:
                                <Tag color="red" className="Tag_style">未生成</Tag>}
                        </Form.Item>
                        <Form.Item label="人员结构表" name="StaffStructureStatus">
                            {this.state.StaffStructureStatus === true?
                                <Tag color="green" className="Tag_style" >已生成</Tag>:
                                <Tag color="red" className="Tag_style">未生成</Tag>}
                        </Form.Item>
                        <Form.Item label="社保缴费证明" name="StaffSecurityStatus">
                            {this.state.StaffSecurityStatus === true?
                                <Tag color="green" className="Tag_style" >已上传</Tag>:
                                <Tag color="red" className="Tag_style">未上传</Tag>}
                        </Form.Item>
                    </Form>
                </Panel>
            </Collapse>
        )
        const Content8 = (
            <Collapse bordered={false}>
                <Panel header="展开全部" key="6">
                    <Form>
                        <Form.Item label="高品技术和技术指标具体说明"
                                   name="HighTechSpecificStatus">
                            {
                                this.state.company.area === '青岛'&&
                                <Tag color="gray" className="Tag_style" >青岛无此文件</Tag>
                            }
                            {
                                this.state.company.area === '山东其他地区'&&
                                <Tag color="gray" className="Tag_style" >山东其他地区无此文件</Tag>
                            }
                            {this.state.HighTechSpecificStatus === true&&
                            this.state.company.area === '江苏'&&
                            <Tag color="green" className="Tag_style" >已生成</Tag>}
                            {this.state.HighTechSpecificStatus === false&&
                            this.state.company.area === '江苏'&&
                            <Tag color="red" className="Tag_style">未生成</Tag>}
                        </Form.Item>
                    </Form>
                </Panel>
            </Collapse>
        )
        const Content9 = (
            <Collapse bordered={false}>
                <Panel header="展开全部" key="7">
                    <Form>
                        <Form.Item label="研究开发组织管理水平总体情况说明"
                                   name="OrganizationOverAllStatus">
                            {this.state.OrganizationOverAllStatus === true?
                                <Tag color="green" className="Tag_style" >已生成/上传</Tag>:
                                <Tag color="red" className="Tag_style">未生成/上传</Tag>}
                        </Form.Item>
                        <Form.Item label="研究开发组织管理水平指标逐项说明"
                                   name="OrganizationItemStatus">
                            {this.state.OrganizationItemStatus === true?
                                <Tag color="green" className="Tag_style" >已生成/上传</Tag>:
                                <Tag color="red" className="Tag_style">未生成/上传</Tag>}
                        </Form.Item>
                        <Form.Item label="研发项目管理制度"
                                   name="RDProjectManageStatus">
                            {this.state.RDProjectManageStatus === true?
                                <Tag color="green" className="Tag_style" >已生成/上传</Tag>:
                                <Tag color="red" className="Tag_style">未生成/上传</Tag>}
                        </Form.Item>
                        <Form.Item label="研发投入核算管理制度"
                                   name="RDInvestManageStatus">
                            {this.state.RDInvestManageStatus === true?
                                <Tag color="green" className="Tag_style" >已生成/上传</Tag>:
                                <Tag color="red" className="Tag_style">未生成/上传</Tag>}
                        </Form.Item>
                        <Form.Item label="研发辅助账管理办法"
                                   name="RDAuxiliaryAccountStatus">
                            {this.state.RDAuxiliaryAccountStatus === true?
                                <Tag color="green" className="Tag_style" >已生成/上传</Tag>:
                                <Tag color="red" className="Tag_style">未生成/上传</Tag>}
                        </Form.Item>
                        <Form.Item label="企业研发准备金制度"
                                   name="ReserveFundStatus">
                            {this.state.ReserveFundStatus === true?
                                <Tag color="green" className="Tag_style" >已生成/上传</Tag>:
                                <Tag color="red" className="Tag_style">未生成/上传</Tag>}
                        </Form.Item>
                        <Form.Item label="关于成立研发中心的通知"
                                   name="RDCenterFoundStatus">
                            {this.state.RDCenterFoundStatus === true?
                                <Tag color="green" className="Tag_style" >已生成/上传</Tag>:
                                <Tag color="red" className="Tag_style">未生成/上传</Tag>}
                        </Form.Item>
                        <Form.Item label="研发中心建设情况说明"
                                   name="RDCenterStatus">
                            {this.state.RDCenterStatus === true?
                                <Tag color="green" className="Tag_style" >已生成/上传</Tag>:
                                <Tag color="red" className="Tag_style">未生成/上传</Tag>}
                        </Form.Item>
                        <Form.Item label="研发设备明细表"
                                   name="RDEquipmentStatus">
                            {this.state.RDEquipmentStatus === true?
                                <Tag color="green" className="Tag_style" >已生成/上传</Tag>:
                                <Tag color="red" className="Tag_style">未生成/上传</Tag>}
                        </Form.Item>
                        <Form.Item label="产学研协议（选填，不计入）"
                                   name="SchoolProtocolStatus">
                            {this.state.SchoolProtocolStatus === true?
                                <Tag color="green" className="Tag_style" >已上传</Tag>:
                                <Tag color="red" className="Tag_style">未上传</Tag>}
                        </Form.Item>
                        <Form.Item label="科技成果转化的组织实施与激励奖励制度"
                                   name="PatentTransferManageStatus">
                            {this.state.PatentTransferManageStatus === true?
                                <Tag color="green" className="Tag_style" >已生成/上传</Tag>:
                                <Tag color="red" className="Tag_style">未生成/上传</Tag>}
                        </Form.Item>
                        <Form.Item label="开放式创新创业平台制度"
                                   name="OpenInnovationStatus">
                            {this.state.OpenInnovationStatus === true?
                                <Tag color="green" className="Tag_style" >已生成/上传</Tag>:
                                <Tag color="red" className="Tag_style">未生成/上传</Tag>}
                        </Form.Item>
                        <Form.Item label="科技人员培训管理制度"
                                   name="TechPersonTrainStatus">
                            {this.state.TechPersonTrainStatus === true?
                                <Tag color="green" className="Tag_style" >已生成/上传</Tag>:
                                <Tag color="red" className="Tag_style">未生成/上传</Tag>}
                        </Form.Item>
                        <Form.Item label="科技人员培养进修制度"
                                   name="TechPersonRefreshStatus">
                            {this.state.TechPersonRefreshStatus === true?
                                <Tag color="green" className="Tag_style" >已生成/上传</Tag>:
                                <Tag color="red" className="Tag_style">未生成/上传</Tag>}
                        </Form.Item>
                        <Form.Item label="人才引进制度"
                                   name="TalentAcquisitionStatus">
                            {this.state.TalentAcquisitionStatus === true?
                                <Tag color="green" className="Tag_style" >已生成/上传</Tag>:
                                <Tag color="red" className="Tag_style">未生成/上传</Tag>}
                        </Form.Item>
                        <Form.Item label="研发人员绩效考核制度"
                                   name="PerformanceReviewStatus">
                            {this.state.PerformanceReviewStatus === true?
                                <Tag color="green" className="Tag_style" >已生成/上传</Tag>:
                                <Tag color="red" className="Tag_style">未生成/上传</Tag>}
                        </Form.Item>
                        <Form.Item label="设备照片"
                                   name="RDEquipmentPhotoStatus">
                            {this.state.RDEquipmentPhotoStatus === true?
                                <Tag color="green" className="Tag_style" >已上传</Tag>:
                                <Tag color="red" className="Tag_style">未上传</Tag>}
                        </Form.Item>
                        <Form.Item label="研发费用辅助帐"
                                   name="RDExpenseStatus">
                            {this.state.RDExpenseStatus === true?
                                <Tag color="green" className="Tag_style" >已上传</Tag>:
                                <Tag color="red" className="Tag_style">未上传</Tag>}
                        </Form.Item>
                    </Form>
                </Panel>
            </Collapse>
        )
        return (
            <div className='content-page-header-main'>
                <PageHeader
                    ghost={false}
                    title={this.state.companyName}
                    subTitle={""}
                >
                    <Descriptions size="small" column={3}>
                        <Descriptions.Item label="注册时间">
                            <li>{this.state.company.registerTime}</li>
                        </Descriptions.Item>
                        <Descriptions.Item label="所属地区">{this.state.company.area}</Descriptions.Item>
                    </Descriptions>
                    <div style={{width:'100%',margin:'3% 40%'}}>
                        {
                            this.state.company.area === '江苏'&&
                            <Progress type="circle" percent={parseInt((this.state.current/8)*100)} />
                        }
                        {
                            this.state.company.area === '青岛'&&
                            <Progress type="circle" percent={parseInt((this.state.current/7)*100)} />
                        }
                        {
                            this.state.company.area === '山东其他地区'&&
                            <Progress type="circle" percent={parseInt((this.state.current/7)*100)} />
                        }
                        <div style={{fontSize:'20px',marginTop:'20px',marginLeft:'20px'}}>模块进度</div>
                    </div>
                    <div style={{fontSize:'20px',marginBottom:'10px'}}>
                        {Content1}
                    </div>
                    {
                        this.state.company.area === '江苏'&&
                            <div>
                                <div style={{fontSize:'20px',marginBottom:'10px'}}>
                                    <StarOutlined style={{marginRight:'5px'}}/>资质证明
                                    <Progress percent={parseInt((this.state.percent1/1)*100)} />
                                    {Content2}
                                </div>
                                <div style={{fontSize:'20px',marginBottom:'10px'}}>
                                    <StarOutlined style={{marginRight:'5px'}}/>知识产权
                                    <Progress percent={parseInt((this.state.percent2/2)*100)}  />
                                    {Content3}
                                </div>
                                <div style={{fontSize:'20px',marginBottom:'10px'}}>
                                    <StarOutlined style={{marginRight:'5px'}}/>审计报告<Progress percent={parseInt((this.state.percent3/4)*100)} />
                                    {Content4}
                                </div>
                                <div style={{fontSize:'20px',marginBottom:'10px'}}>
                                    <StarOutlined style={{marginRight:'5px'}}/>成果转化<Progress percent={parseInt((this.state.percent4/3)*100)} />
                                    {Content5}
                                </div>
                                <div style={{fontSize:'20px',marginBottom:'10px'}}>
                                    <StarOutlined style={{marginRight:'5px'}}/>立项<Progress percent={parseInt((this.state.percent5/2)*100)}  />
                                    {Content6}
                                </div>
                                <div style={{fontSize:'20px',marginBottom:'10px'}}>
                                    <StarOutlined style={{marginRight:'5px'}}/>人员<Progress percent={parseInt((this.state.percent6/4)*100)} />
                                    {Content7}
                                </div>
                                <div style={{fontSize:'20px',marginBottom:'10px'}}>
                                    <StarOutlined style={{marginRight:'5px'}}/>高品<Progress percent={parseInt((this.state.percent7/1)*100)}  />
                                    {Content8}
                                </div>
                                <div style={{fontSize:'20px',marginBottom:'10px'}}>
                                    <StarOutlined style={{marginRight:'5px'}}/>组织管理<Progress percent={parseInt((this.state.percent8/17)*100)}  />
                                    {Content9}
                                </div>
                                <div style={{fontSize:'20px',marginBottom:'10px'}}>
                                    <StarOutlined style={{marginRight:'5px'}}/>荣誉资质（选填，不计入总进度）<Progress percent={parseInt((this.state.percent9/1)*100)} />
                                </div>
                            </div>
                    }
                    {
                        this.state.company.area === '青岛'&&
                        <div>
                            <div style={{fontSize:'20px',marginBottom:'10px'}}>
                                <StarOutlined style={{marginRight:'5px'}}/>资质证明<Progress percent={parseInt((this.state.percent1/2)*100)} />
                                {Content2}
                            </div>
                            <div style={{fontSize:'20px',marginBottom:'10px'}}>
                                <StarOutlined style={{marginRight:'5px'}}/>知识产权<Progress percent={parseInt((this.state.percent2/4)*100)}  />
                                {Content3}
                            </div>
                            <div style={{fontSize:'20px',marginBottom:'10px'}}>
                                <StarOutlined style={{marginRight:'5px'}}/>审计报告<Progress percent={parseInt((this.state.percent3/4)*100)} />
                                {Content4}
                            </div>
                            <div style={{fontSize:'20px',marginBottom:'10px'}}>
                                <StarOutlined style={{marginRight:'5px'}}/>成果转化<Progress percent={parseInt((this.state.percent4/3)*100)} />
                                {Content5}
                            </div>
                            <div style={{fontSize:'20px',marginBottom:'10px'}}>
                                <StarOutlined style={{marginRight:'5px'}}/>立项<Progress percent={parseInt((this.state.percent5/2)*100)}  />
                                {Content6}
                            </div>
                            <div style={{fontSize:'20px',marginBottom:'10px'}}>
                                <StarOutlined style={{marginRight:'5px'}}/>人员<Progress percent={parseInt((this.state.percent6/3)*100)} />
                                {Content7}
                            </div>
                            <div style={{fontSize:'20px',marginBottom:'10px'}}>
                                <StarOutlined style={{marginRight:'5px'}}/>组织管理<Progress percent={parseInt((this.state.percent8/17)*100)}  />
                                {Content9}
                            </div>
                            <div style={{fontSize:'20px',marginBottom:'10px'}}>
                                <StarOutlined style={{marginRight:'5px'}}/>荣誉资质（选填，不计入总进度）<Progress percent={parseInt((this.state.percent9/1)*100)} />
                            </div>
                        </div>
                    }
                    {
                        this.state.company.area === '山东其他地区'&&
                        <div>
                            <div style={{fontSize:'20px',marginBottom:'10px'}}>
                                <StarOutlined style={{marginRight:'5px'}}/>资质证明<Progress percent={parseInt((this.state.percent1/2)*100)} />
                                {Content2}
                            </div>
                            <div style={{fontSize:'20px',marginBottom:'10px'}}>
                                <StarOutlined style={{marginRight:'5px'}}/>知识产权<Progress percent={parseInt((this.state.percent2/2)*100)}  />
                                {Content3}
                            </div>
                            <div style={{fontSize:'20px',marginBottom:'10px'}}>
                                <StarOutlined style={{marginRight:'5px'}}/>审计报告<Progress percent={parseInt((this.state.percent3/4)*100)} />
                                {Content4}
                            </div>
                            <div style={{fontSize:'20px',marginBottom:'10px'}}>
                                <StarOutlined style={{marginRight:'5px'}}/>成果转化<Progress percent={parseInt((this.state.percent4/3)*100)} />
                                {Content5}
                            </div>
                            <div style={{fontSize:'20px',marginBottom:'10px'}}>
                                <StarOutlined style={{marginRight:'5px'}}/>立项<Progress percent={parseInt((this.state.percent5/2)*100)}  />
                                {Content6}
                            </div>
                            <div style={{fontSize:'20px',marginBottom:'10px'}}>
                                <StarOutlined style={{marginRight:'5px'}}/>人员<Progress percent={parseInt((this.state.percent6/2)*100)} />
                                {Content7}
                            </div>
                            <div style={{fontSize:'20px',marginBottom:'10px'}}>
                                <StarOutlined style={{marginRight:'5px'}}/>组织管理<Progress percent={parseInt((this.state.percent8/17)*100)}  />
                                {Content9}
                            </div>
                            <div style={{fontSize:'20px',marginBottom:'10px'}}>
                                <StarOutlined style={{marginRight:'5px'}}/>荣誉资质（选填，不计入总进度）<Progress percent={parseInt((this.state.percent9/1)*100)} />
                            </div>
                        </div>
                    }
                </PageHeader>

            </div>
        )
    }
}

export default CompanyPaceMain;